import { useContext, useEffect, useMemo } from 'react';
import Analytics, { AnalyticsContext } from '../analytics';
export function useAnalytics(player, viewerId, options) {
    const { getVideoElement, setDefaultPlayerConfig, defaultPlayerConfig, defaultTimeInterval } = useContext(AnalyticsContext);
    const analytics = useMemo(() => new Analytics({
        ...options,
        timeInterval: options?.timeInterval || defaultTimeInterval,
    }), 
    // options will be updated in useEffect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    useEffect(() => {
        analytics.updateOptions({
            ...options,
            timeInterval: options?.timeInterval || defaultTimeInterval,
        });
    }, 
    // options are serialized as deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    options ? Array.from(Object.values(options)) : []);
    useEffect(() => {
        if (player === false) {
            return;
        }
        if (player.current) {
            getVideoElement(player.current, options?.playerConfig).then((video) => {
                if (video) {
                    analytics.attach({
                        video,
                        viewerId,
                    });
                    return () => {
                        analytics.detach();
                    };
                }
            });
        }
    }, [analytics, viewerId, options?.videoId, player, getVideoElement, options?.playerConfig]);
    useEffect(() => () => {
        analytics.detach();
    }, [analytics]);
    return {
        analytics,
        setDefaultPlayerConfig,
        defaultPlayerConfig,
    };
}
